<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <v-col cols="12" md="10" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-text class="pa-1">
            <v-data-table
            :headers="hintHead"
            :items="hintList"
            hide-default-footer
            class="elevation-2"
            :mobile-breakpoint="0"
            sort-by="pwd_hint_quest"
            disable-pagination
            >
            <template slot="item" slot-scope="props">
              <tr @click="prepareUpdate(props.item)">
                <td>{{ props.item.pwd_hint_quest }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" grid-list-md fluid full-height>
        <v-form ref="lForm" id="form" @submit.prevent="saveChanges(lAction)">
          <v-card flat>
            <v-card-title class="px-0 py-2">
              {{ handy.startWithUpper(lAction) + ' Hint' }}
            </v-card-title>
            <v-card-text class="px-0 py-3">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-textarea
                  v-model="lPwdHint.pwd_hint_quest"
                  label="Hint Question"
                  :rules="[rules.required]"
                  hide-details
                  rows="3"
                  maxlength="100"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="lAction === 'update' && (config.IS_EDITED_BY_USER)" @click="deleteHint()">delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click.stop="lAction = 'view'">Close</v-btn>
              <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-container>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view' && (config.IS_EDITED_BY_USER)"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-col>
</v-row>
<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      search: '',
      beingSaved: false,
      lAction: 'view',
      lPwdHint: {},
      hintList: [],
      hintHead: [
        { text: 'Hint Question', value: 'pwd_hint_quest' },
      ]
    }
  },
  created () {
    this.loadPwdHints()
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    getEmptyHint () {
      return {
        vendor_id: config.VENDOR_ID,
        pwd_hint_quest: ''
      }
    },
    prepareCreate () {
      this.lPwdHint = this.getEmptyHint()
      this.lAction = 'create'
    },
    prepareUpdate (curHint) {
      this.lPwdHint = Object.assign({}, curHint) // keep the original object safely before changes
      this.lAction = 'update'
    },
    deleteHint () {
      this.saveChanges('delete')
    },
    saveChanges (action) {
      if (action === 'delete') {
        if (!confirm('Sure, you want to delete hint "' + this.lPwdHint.pwd_hint_quest + '"?')) {
          return
        }
      } else {
        if (!this.$refs.lForm.validate()) {
          return
        }
      }
      // proceed with changes
      this.beingSaved = true
      this.axios.post(config.API_URL + '/user-pwd-hint/' + action, this.lPwdHint)
      .then(response => {
        // update the object in front end
        this.loadPwdHints()
        this.lAction = 'view'
        this.beingSaved = false
        if (action !== 'delete') {
          this.msg('Saved successfully', 1)
        } else {
          this.msg('Deleted successfully', 1)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    loadPwdHints () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUserPwdHintQuestByVendorId/', qry)
      .then(response => {
        this.hintList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.hintList = []
      })
    }
  }
}
</script>
